const features = [
  {
    title: '《长安十二时辰之风起云涌》',
    desc: '古装悬疑巨制续作，原班人马回归，再现盛世长安暗流涌动的惊险故事。全新篇章，格局更大、悬念更深。',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20drama%20cinematic%20scene%2C%20Tang%20dynasty%20architecture%20with%20warm%20golden%20lighting%2C%20historical%20costume%20drama%20atmosphere%2C%20epic%20scale%20composition%2C%20misty%20ancient%20city%20backdrop%2C%20dramatic%20mood%20with%20rich%20amber%20and%20coral%20tones%2C%20premium%20cinematic%20photography&width=800&height=500&seq=carousel-01-drama&orientation=landscape',
    tag: '古装悬疑',
  },
  {
    title: '《锦瑟年华》',
    desc: '一部跨越三十年的年代情感大戏，讲述几代人在时代变迁中的爱恨纠葛。豆瓣开分 8.7，口碑持续走高。',
    img: 'https://readdy.ai/api/search-image?query=Retro%20Chinese%20emotional%20drama%20scene%2C%20vintage%201980s%20Chinese%20street%20setting%2C%20nostalgic%20warm%20lighting%2C%20romantic%20atmosphere%2C%20period%20drama%20aesthetic%20with%20soft%20sepia%20and%20rose%20tones%2C%20emotional%20cinematic%20photography%2C%20elegant%20composition&width=800&height=500&seq=carousel-02-drama&orientation=landscape',
    tag: '年代情感',
  },
  {
    title: '《暗夜追光》',
    desc: '硬核犯罪悬疑剧，刑警与高智商罪犯的巅峰对决。节奏紧凑，每一集都是反转，国产剧集年度口碑黑马。',
    img: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20drama%20scene%2C%20modern%20urban%20night%20cityscape%20with%20neon%20lights%2C%20noir%20detective%20atmosphere%2C%20dark%20moody%20lighting%20with%20cool%20shadows%20and%20warm%20accents%2C%20suspenseful%20cinematic%20composition%2C%20professional%20film%20photography%2C%20high%20contrast&width=800&height=500&seq=carousel-03-drama&orientation=landscape',
    tag: '犯罪悬疑',
  },
  {
    title: '《山海情缘》',
    desc: '现实主义题材力作，以山海协作扶贫为背景，展现普通人不平凡的奋斗故事。温情励志，催人泪下。',
    img: 'https://readdy.ai/api/search-image?query=Rural%20Chinese%20landscape%20drama%20scene%2C%20beautiful%20mountain%20and%20sea%20coastal%20village%20view%2C%20warm%20natural%20sunlight%2C%20heartfelt%20slice%20of%20life%20atmosphere%2C%20realistic%20rural%20Chinese%20setting%20with%20golden%20hour%20lighting%2C%20inspirational%20cinematic%20photography%2C%20hopeful%20mood&width=800&height=500&seq=carousel-04-drama&orientation=landscape',
    tag: '现实题材',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-18 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">重磅推荐</h2>
          <p className="text-sm text-foreground-500">编辑精选必看好剧，每一部都值得追</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((item) => (
            <a
              key={item.title}
              href="#cards"
              className="group block bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-md text-xs font-medium bg-primary-500/90 text-background-50 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}